var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.81 32.35A45.4 45.4 0 1 0 91 98.91a4.2 4.2 0 0 0 .58.88L103 112.55a4.07 4.07 0 0 0 6.08-5.4l-11.4-12.76a3.7 3.7 0 0 0-.81-.68 45.46 45.46 0 0 0 .94-61.36M89.18 91a38 38 0 1 1 3.14-53.71A38.08 38.08 0 0 1 89.18 91",
    className: "search_svg__cls-1"
  })));
};
export default SvgSearch;